<template>
  <div class="reappraisal-board-selector">
    <el-card shadow="hover" class="selector-card">
      <div class="card-content">
        <div class="top-section">
          <h3>Επιτροπή Επανεξέτασης (3 μέλη)</h3>

          <el-select
            v-model="selected"
            multiple
            filterable
            placeholder="Επιλέξτε 3 μέλη"
            style="width: 100%;"
            @change="handleChange"
          >
            <el-option
              v-for="person in people"
              :key="person.id"
              :label="person.name"
              :value="person.id"
              :disabled="isDisabled(person.id)"
            />
          </el-select>
        </div>

        <div class="bottom-section">
          <div class="leader-select">
            <h4>Συντονιστής:</h4>
            <el-select
              v-model="leader"
              placeholder="Επιλέξτε συντονιστή"
              style="width: 100%"
              @change="handleLeaderChange"
              :disabled="!canChangeLeader"
            >
              <el-option
                v-for="personId in selected"
                :key="personId"
                :label="getPersonName(personId)"
                :value="personId"
                :disabled="isLeaderDisabled(personId)"
              />
            </el-select>
          </div>

          <div class="warning-container">
            <div v-if="!isComplete" class="warning">
              Επιλογή 3 μελών και του συντονιστή
            </div>
            <div v-else class="warning-placeholder"></div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'ReappraisalBoardSelector',
  props: {
    people: {
      type: Array,
      required: true
    },
    fixedIds: {
      type: Array,
      required: true
    },
    initialLeader: {
      type: String,
      default: null
    },
    initialSelected: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      selected: [],
      leader: null,
      isComplete: false,
      canChangeLeader: true
    }
  },
  watch: {
    people: {
      immediate: true,
      handler () {
        this.initializeData()
      }
    }
  },
  methods: {
    initializeData () {
      const validIds = idList =>
        idList.filter(id => {
          const exists = this.people.some(p => p.id === id)
          if (!exists) {
            console.warn(`Το id ${id} δεν υπάρχει στη λίστα people και αγνοείται.`)
          }
          return exists
        })

      const validFixed = validIds(this.fixedIds)
      const validInitialSelected = validIds(this.initialSelected)

      // Συνδυασμός χωρίς διπλότυπα
      const combined = Array.from(new Set([...validFixed, ...validInitialSelected]))
      this.selected = combined

      const leaderExists = this.people.some(p => p.id === this.initialLeader)
      if (this.initialLeader && leaderExists) {
        this.leader = this.initialLeader
        if (!this.selected.includes(this.initialLeader)) {
          this.selected.push(this.initialLeader)
        }
      }

      this.canChangeLeader = !validFixed.includes(this.leader)
      this.emitChange()
    },
    isDisabled (id) {
      return this.fixedIds.includes(id) ||
        (this.selected.length >= 3 && !this.selected.includes(id))
    },
    isLeaderDisabled (id) {
      return this.fixedIds.includes(id)
    },
    handleChange () {
      const validFixed = this.fixedIds.filter(id =>
        this.people.some(p => p.id === id)
      )
      this.selected = Array.from(new Set([...validFixed, ...this.selected]))

      if (this.selected.length > 3) {
        const extra = this.selected.filter(id => !validFixed.includes(id))
        this.selected = [...validFixed, ...extra.slice(0, 3 - validFixed.length)]
      }

      if (this.leader && !this.selected.includes(this.leader)) {
        this.leader = null
      }

      this.emitChange()
    },
    handleLeaderChange () {
      this.emitChange()
    },
    emitChange () {
      this.isComplete = this.selected.length === 3 && !!this.leader
      this.$emit('board-changed', {
        leader: this.leader,
        members: this.selected,
        isComplete: this.isComplete
      })
    },
    getPersonName (id) {
      const person = this.people.find(p => p.id === id)
      return person ? person.name : ''
    }
  }
}
</script>

<style scoped>
.reappraisal-board-selector {
  max-width: 500px;
  margin: 0 auto;
}

.selector-card {
  min-height: 322px; /* Ελάχιστο ύψος του card */
}

.card-content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  min-height: 318px; /* Ελάχιστο ύψος του περιεχομένου */
}

.top-section {
  flex-grow: 0;
}

.bottom-section {
  margin-top: auto;
  flex-grow: 0;
}

.leader-select {
  margin-top: 20px;
}

.warning-container {
  min-height: 20px; /* Σταθερό ύψος για το χώρο του warning */
  margin-top: 20px;
}

.warning {
  color: #c0392b;
  font-size: 14px;
}

.warning-placeholder {
  height: 40px; /* Ίδιο ύψος με το warning για να διατηρείται η διάταξη */
}
</style>



// WEBPACK FOOTER //
// src/components/common/ReappraisalBoardSelector.vue